/**
 * Home grounds for the PUBLIC pages — the join form and the payment page.
 *
 * Those screens have no club state: a stranger filling in a membership request
 * is not signed in, and the whole roster is exactly what they must not be able
 * to read. So the list comes from GET /grounds, which returns only the names of
 * public places the club runs at.
 *
 * It starts EMPTY and is the club's own list once it arrives (owner's
 * direction, 2 Sep 2026). It used to start with the three Tirupur grounds as a
 * never-empty fallback, but on a multi-tenant platform that offered a Chennai
 * applicant a ground in Tirupur — a wrong answer is worse than a late one, and
 * the form renders the field disabled until the real list lands.
 */

import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export function usePublicGrounds() {
  const [grounds, setGrounds] = useState({});

  useEffect(() => {
    let alive = true;
    api
      .publicGrounds()
      .then((res) => {
        if (alive && res?.grounds) setGrounds(res.grounds);
      })
      // Silent on purpose: an error toast about a dropdown would not tell the
      // applicant anything they can act on. The field simply stays empty.
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return grounds;
}
